import React, {useEffect, useState} from "react";
import {Button, CardContent, styled, Tab, Tabs} from "@mui/material";
import PageLayout from "../components/layout/PageLayout";
import {SimpleTreeView, TreeItem} from "@mui/x-tree-view";
import {fetchCategories, selectCategories} from "../store/categorySlice";
import {useDispatch, useSelector} from "react-redux";
import {AddCircle} from "@mui/icons-material";
import EditCategoryForm from "../components/form/EditCategoryForm";
import CategoryService from "../services/CategoryService";
import {StyledTab} from "../components/utils/StyleConstants";
import {useTranslation} from "react-i18next";



const CategoriesPage = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const [selectedTab, setSelectedTab] = useState("EXPENSE")
    const categories = useSelector(state => selectCategories(state));
    const [selectedCategory, setSelectedCategory] = useState(null);

    useEffect(() => {
        dispatch(fetchCategories());
    }, []);

    const buildTree = (parentId) => {
        return categories ? CategoryService.getActive(categories).filter(category => category.type === selectedTab).filter(category => category.parentId === parentId).map(category => {
            return <TreeItem key={category.id} itemId={"" + category.id} label={category.name}
                             sx={{ml: parentId ? 1 : 0}}
            onClick={() => setSelectedCategory(category)}>
                {buildTree(category.id)}
            </TreeItem>
        }) : ""
    }

    return (
        <PageLayout
            title={t("pages.categories.title")}
            cardStyle={{ display: "flex", flexDirection: "column" }}
            tabs={
                <Tabs value={selectedTab}
                      onChange={(event, newValue) => {setSelectedTab(newValue); setSelectedCategory(null)}}
                      centered
                      TabIndicatorProps={{
                          style: {
                              color: "white",
                              background: "white"
                          }
                      }}
                >
                    <StyledTab label={t("pages.categories.tabs.expenses")} value={"EXPENSE"}/>
                    <StyledTab label={t("pages.categories.tabs.incomes")} value={"INCOME"}/>
                </Tabs>
            }
        >
            <CardContent sx={{ flex: 1, minHeight: 0, overflowY: "auto", pb: "120px" }}>
                <SimpleTreeView>
                    {buildTree(null)}
                </SimpleTreeView>
            </CardContent>
            <Button style={{position: "absolute", bottom: 30, right: "45%", fontSize: "4rem"}}
                    onClick={(event) => setSelectedCategory({name: "", type: selectedTab})}>
                <AddCircle fontSize="inherit"/>
            </Button>
            {selectedCategory && <EditCategoryForm category={selectedCategory}
                                                   onCancel={(e) => setSelectedCategory(null)}></EditCategoryForm>}
        </PageLayout>
    );
}

export default CategoriesPage